<fieldset class="grid" aria-label="Einstellungen zu ZERTIFIKATSAUSZUG" data-test-id="aufgabe-zertifikatsauszug-root">
	<div class="row">
		<div class="column taetigkeit">
			<mat-radio-group
				aria-label="Bitte Aktion wählen"
				class="column"
				[formControl]="bodyControls.zertifikatTaetigkeit"
				(change)="toggleTaetigkeitAndSendenControls($event.value)"
				data-test-id="aufgabe-zertifikatsauszug-taetigkeit">
				<mat-radio-button
					color="primary"
					class="focus-inwards-dark"
					[value]="taetigkeiten.NOTIZ"
					data-test-id="notiz-radio-button">
					gem. Notiz
				</mat-radio-button>
				<mat-radio-button
					color="primary"
					class="focus-inwards-dark"
					[value]="taetigkeiten.FERTIGEN"
					data-test-id="fertigen-radio-button">
					fertigen
				</mat-radio-button>
				<mat-radio-button
					color="primary"
					class="focus-inwards-dark"
					[value]="taetigkeiten.VORHANDEN"
					data-test-id="vorhanden-radio-button">
					vorhanden
				</mat-radio-button>
			</mat-radio-group>
			@if (bodyControls.taetigkeit.enabled) {
				<mat-radio-group
					aria-label="Bitte Aktion wählen"
					class="column"
					[formControl]="bodyControls.taetigkeit"
					data-test-id="aufgabe-zertifikatsauszug-versandtaetigkeit">
					<mat-radio-button
						color="primary"
						class="focus-inwards-dark"
						[value]="versandTaetigkeit.SENDEN_AN"
						data-test-id="senden-an-radio-button">
						senden an
					</mat-radio-button>
					<mat-radio-button
						color="primary"
						class="focus-inwards-dark"
						[value]="versandTaetigkeit.AUSHAENDIGEN_AN"
						data-test-id="aushaendigen-an-radio-button">
						aushändigen an
					</mat-radio-button>
				</mat-radio-group>
			}
		</div>
		@if (bodyControls.empfaenger.enabled) {
			<schir-int-client-kontakt-kategorie-checkboxes
				class="column"
				[excludeEingetragenerEigentuemer]="excludeEingetragenerEigentuemer()"
				[control]="bodyControls.empfaenger"
				data-test-id="kontakt-kategorie-checkbox-root" />
		}
	</div>
	@if (bodyControls.vorabPerFax.enabled) {
		<div class="row">
			<mat-checkbox
				class="column focus-inwards-dark"
				color="primary"
				[formControl]="bodyControls.vorabPerFax"
				(change)="toggleFaxEmpfaengerControls($event.checked)"
				data-test-id="vorab-per-fax-checkbox">
				vorab per Fax
			</mat-checkbox>
			@if (bodyControls.faxEmpfaenger.enabled) {
				<schir-int-client-kontakt-kategorie-checkboxes
					class="column"
					[excludeEingetragenerEigentuemer]="excludeEingetragenerEigentuemer()"
					[control]="bodyControls.faxEmpfaenger"
					data-test-id="kontakt-kategorie-checkboxes-fax-empfaenger" />
			}
		</div>
	}
	<schir-int-client-notiz-in-aufgabe-editor class="row note" [aufgabenTyp]="AufgabenTyp.ZERTIFIKATSAUSZUG" />
</fieldset>
